import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';
import { useNavigate } from '@tanstack/react-router';
import type { paths } from '@low6-pickem/api-types';

type CreateQuestionRequest =
  paths['/api/admin/questions']['post']['requestBody']['content']['application/json'];

export const createQuestion = (data: CreateQuestionRequest) =>
  api.post(apiEndpoints.createQuestion, data);

export const useCreateQuestionMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: createQuestion,
    onSuccess: (_response, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      toast.success('Question created successfully');

      // Navigate back to the pickem's questions list
      const pickemId = variables.pickem_id;
      if (pickemId) {
        navigate({
          to: '/dashboard/pickems/$id',
          params: { id: pickemId },
          search: { tenant_id: undefined, tab: 'questions' },
        });
      } else {
        // Fallback to pickems list if no pickem_id
        navigate({ to: '/dashboard/pickems' });
      }
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to create question');
    },
  });
};
